import axios from "axios";
//#region
//BU KISIM GLOBAL APP VUE RENDERLANDIĞI GLOBAL BİR YERE KOY
axios.defaults.baseURL = "http://localhost:3000/"

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  return Promise.reject(error)
})
//#endregion


export function loginReq(userReq) {
  return axios.post("/login", userReq)
}

export function updateUser(userReq) {
  return axios.post("admin/updateuser", userReq)
}
export function getUserList(userReq) {
  return axios.post("admin/userlist", userReq)
}
